import React, { ReactElement } from "react";
import { useMutation } from "@tanstack/react-query";
import { Dialog, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button, ButtonProps } from "../ui/button";
import Spinner from "../ui/spinner";

export interface ConfirmationDialogConfig {
    title: string | ReactElement;
    body: string | ReactElement;
    confirm: () => Promise<unknown>;
    confirmButtonText?: string;
    confirmButtonVariant?: ButtonProps["variant"];
    cancelButtonText?: string;
    open?: boolean;
    onClose?: () => void;
}

export default function ConfirmationDialog(props: React.PropsWithChildren<ConfirmationDialogConfig>) {
    const { isPending, mutate } = useMutation({
        mutationFn: props.confirm,
    });
    const useFragment = !!props.onClose;
    return (
        <Dialog open={isPending || props.open} onOpenChange={!isPending ? props.onClose : undefined}>
            {props.children}
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle className={"text-start"}>{props.title}</DialogTitle>
                </DialogHeader>
                {!isPending && (
                    <>
                        {props.body}
                        <DialogFooter>
                            <DialogClose asChild>
                                <Button variant={"secondary"}>{props.cancelButtonText ?? "Cancel"}</Button>
                            </DialogClose>
                            {useFragment ? (
                                <Button onClick={() => mutate()} variant={props.confirmButtonVariant}>
                                    {props.confirmButtonText ?? "Yes"}
                                </Button>
                            ) : (
                                <DialogClose asChild>
                                    <Button onClick={() => mutate()} variant={props.confirmButtonVariant}>
                                        {props.confirmButtonText ?? "Yes"}
                                    </Button>
                                </DialogClose>
                            )}
                        </DialogFooter>
                    </>
                )}
                {isPending && (
                    <div className={"flex w-full flex-col items-center justify-center p-6"}>
                        <Spinner />
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
}
